import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TotalContractReportComponent} from './total-contract-report/total-contract-report.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../../../../../core/material';
import {SharedModule} from '../../../../../shared/shared.module';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {NgZorroAntdModule} from 'ng-zorro-antd';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {MatAutocompleteModule, MatInputModule, MatProgressBarModule} from '@angular/material';
import {NgxMaskModule} from 'ngx-mask';
import {NgMatAutocompleteModule} from '../../../../../shared/components/autocomplete/autocomplete.module';
import {SmsQuantityReportComponent} from './sms-quantity-report/sms-quantity-report.component';
import {SmsMoneyReportComponent} from './sms-money-report/sms-money-report.component';
import {ContractEnterpriseCreateComponent} from './contract-enterprise-create/contract-enterprise-create.component';
import {ContractEnterpriseReceiveComponent} from './contract-enterprise-receive/contract-enterprise-receive.component';
import {ContractPersonalCreateComponent} from './contract-personal-create/contract-personal-create.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { HistoryReportComponent } from './history-report/history-report.component';
import { CertificateMoneyReportComponent } from './certificate-money-report/certificate-money-report.component';
import { TimestampQuantityReportComponent } from './timestamp-quantity-report/timestamp-quantity-report.component';
import {MatRippleModule} from "@angular/material/core";
import {ContractUserReportComponent} from "./contract-user-report/contract-user-report.component";
import { ContractProcessingReportComponent } from './contract-processing-report/contract-processing-report.component';
import { SmsHistoryReportComponent } from './sms-history-report/sms-history-report.component';

@NgModule({
    declarations: [
        TotalContractReportComponent,
        SmsQuantityReportComponent,
        SmsMoneyReportComponent,
        ContractEnterpriseCreateComponent,
        ContractUserReportComponent,
        ContractEnterpriseReceiveComponent,
        ContractPersonalCreateComponent,
        HistoryReportComponent,
        CertificateMoneyReportComponent,
        TimestampQuantityReportComponent,
        ContractProcessingReportComponent,
        SmsHistoryReportComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TranslateModule,
        MatAutocompleteModule,
        MatProgressBarModule,
        NgMatAutocompleteModule,
        MatInputModule,
        NgxMaskModule.forChild(),
        NgxExtendedPdfViewerModule,
        NgZorroAntdModule,
        SlickCarouselModule,
        Ng4LoadingSpinnerModule.forRoot(),
        MatRippleModule
    ],
    exports: [
        // TranslateModule,
        // TotalContractReportComponent,
    ],
    entryComponents: [
        TotalContractReportComponent,
        SmsQuantityReportComponent,
        SmsMoneyReportComponent,
        ContractEnterpriseCreateComponent,
      ContractUserReportComponent,
        ContractEnterpriseReceiveComponent,
        ContractPersonalCreateComponent,
        CertificateMoneyReportComponent,
        TimestampQuantityReportComponent
    ]
})
export class ReportModule {
}
